export default __webpack_public_path__ + "static/media/lock.af4aa954.svg";